import immerHandleActions from 'redux/utils/immerHandleActions';
import { updateTranstalion } from './actions';
import { transformUpdatedTranslations } from 'utils/converters/wcmTranslations';
import { translations } from 'redux/modules/translation/translations';

interface rootReducer extends types.redux.rootReducer {}
interface updateTranstalionAction extends types.redux.translations.updateTranstalionAction {}

const reducers = {
	[updateTranstalion](state: rootReducer, updatedTranslations: updateTranstalionAction) {
		const newTranslations = transformUpdatedTranslations(updatedTranslations);
		return { ...state, ...newTranslations };
	},
};

const init = translations;

export default immerHandleActions(reducers, init);
